module.exports = __webpack_public_path__ + "pic/19.ffdf0063.png";